import { useToken } from "@gluestack-style/react";
import { Box, HStack, Icon, Pressable, Typography } from "components/ui";
import { X } from "lucide-react-native";
import React, { ComponentProps, ReactNode, useState } from "react";
import { useIsMobile } from "utils/hooks/useIsMobile";

interface Props {
	text?: string;
	variant: "success" | "error" | "warning" | "info";
	icon: ReactNode;
	textWeight?: "bold" | "normal";
	children?: ReactNode;
	borderWidth?: number;
	onDismiss?: () => void;
}

const DismissableContent = ({ textWeight = "bold", text, variant, icon, children, borderWidth = 1, onDismiss, ...props }: ComponentProps<typeof Box> & Props) => {
	const [isVisibile, setIsVisible] = useState(true);
	const isMobile = useIsMobile();
	const resolvedWarningMain = useToken("colors", "warningmain");

	// Use controlled state if onDismiss is provided, otherwise use internal state
	const isVisible = onDismiss ? true : isVisibile;
	const handleDismiss = onDismiss || (() => setIsVisible(false));

	let borderColor = "$successmain";
	let closeIconColor = "$basicblack";
	let textColor = "$basicblack";
	let bgColor = "$basicwhite";
	if (variant === "error") {
		borderColor = "$errormain";
		closeIconColor = "$errormain";
		textColor = "$errormain";
	}
	if (variant === "warning") {
		borderColor = "$warningbright";
		closeIconColor = "$warningmain";
		textColor = "$warningmain";
		bgColor = "$warningdisabled";
	}
	if (variant === "info") {
		borderColor = "$primarylight";
		closeIconColor = "$primarylight";
		textColor = "$primarylight";
		bgColor = "$basicwhite";
	}
	return (
		isVisible && (
			<Box {...props} borderWidth={borderWidth} bg={bgColor} borderColor={borderColor} borderRadius={8} padding={12}>
				<HStack gap={12}>
					<Box maxWidth={30} flex={1}>
						{icon}
					</Box>
					<Box justifyContent="center" flex={8}>
						{children ? (
							children
						) : (
							<Typography sx={{ width: "100%", color: textColor, fontSize: isMobile ? 13 : 16, lineHeight: isMobile ? 17 : "" }} weight={textWeight}>
								{text}
							</Typography>
						)}
					</Box>
					<Box flex={1} maxWidth={30}>
						<Pressable onPress={handleDismiss}>
							<Icon color={closeIconColor} as={X} w={24} h={24} />
						</Pressable>
					</Box>
				</HStack>
			</Box>
		)
	);
};

export default DismissableContent;
